import { formatoPNG, modificarURLServicioWMS, validarUrl, mensaje, proyeccion3857 } from './configuracion';
import TileLayer from 'ol/layer/Tile';
import TileWMS from 'ol/source/TileWMS';

const tipoServicioWeb = document.getElementById('tipoServicioWeb'),
    direccionServicioWeb = document.getElementById('direccionServicioWeb'),
    conectarServicioWeb = document.getElementById('conectarServicioWeb'),
    mensajeServicioWeb = document.getElementById('mensajeServicioWeb'),
    capasTematicas = document.getElementById('capasTematicas'),
    capasDisponibles = document.getElementById('capasDisponibles'),
    agregarGrupos = document.getElementById('agregarGrupos'),    
    agregarCapas = document.getElementById('agregarCapas'),
    limpiarServicioWeb = document.getElementById('limpiarServicioWeb');

    tipoServicioWeb.addEventListener('change', () => {
    direccionServicioWeb.value = '';
    direccionServicioWeb.focus();
});

function limpiar() {
    mensajeServicioWeb.innerHTML = '';
    direccionServicioWeb.classList.remove('is-invalid');
    direccionServicioWeb.value = '';
    direccionServicioWeb.focus();
    conectarServicioWeb.classList.remove('disabled');
    conectarServicioWeb.innerHTML = '<i class="bi bi-box-arrow-down"></i> Conectar';
    capasDisponibles.style.display = 'none';
    agregarGrupos.style.display = 'none';
}

limpiarServicioWeb.addEventListener('click', () => {
    global.mapa.getLayers().forEach(layer => {
        const layerId = layer.get('id');
        if (['servicioWMS', 'servicioWFS', 'servicioRest'].includes(layerId)) {
            global.mapa.removeLayer(layer);
            direccionServicioWeb.value = '';
            global.vista.setCenter(global.centroid3857);
            global.vista.setZoom(global.mapa.getSize()[0] > 1296 ? 6 : 5.4);
        }
    });
    limpiar();
});

conectarServicioWeb.addEventListener('click', () => {
    if (direccionServicioWeb.value.length > 0) {
        conectarServicioWeb.innerHTML = '<span class="spinner-grow spinner-grow-sm" aria-hidden="true"></span> Conectando';

        switch (tipoServicioWeb.value) {
            case 'wms':
                conectarServicioOGCWMS();
                break;
            case 'wfs':
                conectarServicioOGCWFS();
                break;
            case 'rest':
                conectarServicioRestArcGIS();
                break;
        }
    } else {
        direccionServicioWeb.classList.add('is-invalid');
        direccionServicioWeb.focus();
        conectarServicioWeb.innerHTML = '<i class="bi bi-box-arrow-down"></i> Conectar';
    }
});

function conectarServicioOGCWMS() {
    const urlServicioWMS = modificarURLServicioWMS(direccionServicioWeb.value.trim());

    if (validarUrl(urlServicioWMS)) {
        fetch(urlServicioWMS, { mode: 'cors' })
            .then(response => {
                if (!response.ok) throw new Error('La solicitud falló');
                return response.text();
            })
            .then(xmlText => {
                const parser = new DOMParser();
                const xmlDoc = parser.parseFromString(xmlText, 'text/xml');

                const grupoCapas = xmlDoc.querySelectorAll('Layer[queryable="1"]');
                capasDisponibles.style.display = 'block';
                agregarGrupos.style.display = 'block';
                limpiarServicioWeb.classList.remove('disabled');

                grupoCapas.forEach(capa => {
                    const nombre = capa.querySelector('Name').textContent;
                    const titulo = capa.querySelector('Title').textContent;

                    const option = document.createElement('option');
                    option.textContent = titulo;
                    option.value = nombre;
                    capasTematicas.appendChild(option);
                });
            })
            .catch(error => {
                mensaje('mensajeServicioWeb', `<strong>Error:</strong> ${error}`, 'danger')
                limpiar();
            });

        mensajeServicioWeb.innerHTML = '';
        conectarServicioWeb.classList.add('disabled');
        direccionServicioWeb.classList.remove('is-invalid');
        conectarServicioWeb.innerHTML = '<i class="bi bi-box-arrow-down"></i> Conectar';
        limpiarServicioWeb.classList.remove('disabled');
    } else limpiar();
}

agregarCapas.addEventListener('click', () => {
    if (capasTematicas.options.length > 0) {
        const selectedIndex = capasTematicas.selectedIndex;
        const idCapa = capasTematicas.value;
        const nombreCapa = capasTematicas.options[selectedIndex].innerText.substring(0, 25);
        const url = direccionServicioWeb.value;
        const tipo = tipoServicioWeb.value;

        const optionToRemove = capasTematicas.querySelector(`option[value="${idCapa}"]`);
        if (optionToRemove) optionToRemove.remove();

        if (tipo === 'wms') {
            const capaWMS = new TileLayer({
                id: `i${idCapa}`,
                title: nombreCapa,
                source: new TileWMS({
                    url: url,
                    params: { LAYERS: idCapa, FORMAT: formatoPNG },
                    projection: proyeccion3857,
                }),
                visible: true,
            });

            //global.grupoCapasExternos.getLayers().push(capaWMS);
            const capasCollection = global.grupoCapasExternos.getLayers();
            capasCollection.insertAt(0, capaWMS);
            global.layerSwitcher.renderPanel();
        }
    }
});

function conectarServicioOGCWFS() {
    console.log('Conectar servicio OGC WFS no implementado aún.');
}

function conectarServicioRestArcGIS() {
    console.log('Conectar servicio Rest ArcGIS no implementado aún.');
}